import * as i0 from '@angular/core';
import * as i1 from './popover.module';
import * as i2 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/scrolling';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/portal';
import * as i6 from '../cdk/overlay/mapping';
import * as i7 from '../cdk/overlay/overlay-container';
import * as i8 from './popover.directive';
import * as i9 from './popover.component';
import * as i10 from '../cdk/overlay/overlay.module';
export const ElPopoverModuleNgFactory:i0.NgModuleFactory<i1.ElPopoverModule> = (null as any);
var _decl0_0:i2.Dir = (<any>(null as any));
var _decl0_1:i3.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_2:i3.CdkScrollable = (<any>(null as any));
var _decl0_3:i3.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_4:i3.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_5:i4.CdkConnectedOverlay = (<any>(null as any));
var _decl0_6:i4.CdkOverlayOrigin = (<any>(null as any));
var _decl0_7:i5.CdkPortal = (<any>(null as any));
var _decl0_8:i5.CdkPortalOutlet = (<any>(null as any));
var _decl0_9:i6.ElPortalDirective = (<any>(null as any));
var _decl0_10:i6.ElPortalOutletDirective = (<any>(null as any));
var _decl0_11:i7.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_12:i8.ElPopoverDirective = (<any>(null as any));
var _decl0_13:i9.ElPopoverComponent = (<any>(null as any));
var _decl0_14:i10.ElOverlayModule = (<any>(null as any));
var _decl0_15:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_16:i0.ElementRef<any> = (<any>(null as any));
function _View_ElPopoverComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.top;
  currVal_0;
  const currVal_1:any = _decl0_13.topStart;
  currVal_1;
  const currVal_2:any = _decl0_13.topEnd;
  currVal_2;
  const currVal_3:any = _decl0_13.right;
  currVal_3;
  const currVal_4:any = _decl0_13.endTop;
  currVal_4;
  const currVal_5:any = _decl0_13.endBottom;
  currVal_5;
  const currVal_6:any = _decl0_13.bottom;
  currVal_6;
  const currVal_7:any = _decl0_13.bottomStart;
  currVal_7;
  const currVal_8:any = _decl0_13.bottomEnd;
  currVal_8;
  const currVal_9:any = _decl0_13.left;
  currVal_9;
  const currVal_10:any = _decl0_13.startTop;
  currVal_10;
  const currVal_11:any = _decl0_13.startBottom;
  currVal_11;
}
function _View_ElPopoverComponent_1_0():void {
  var _any:any = (null as any);
}
